import { FC, useCallback, useState } from "react"
import { registrationDeleteApi } from "src/domain/api/registration/registrationDeleteApi"
import { Registration } from "src/domain/entities/registration"

import { useAuth } from "../../../domain/hooks"
import { getErrorMessage } from "../../../utils/helpers"
import DeleteItemDialog from "../../shared/DeleteItemDialog"

interface Props {
	registration: Registration
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const RegistrationDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	registration,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handleRegistrationDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await registrationDeleteApi({ id: registration.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [registration, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Registration: ${registration.basic?.firstName.en}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handleRegistrationDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
